<template>
<div :class="theme">
    <div class="container-fluid">

        <!-- Dashboard Header -->
        <div class="row heading pt-2">
            <div class="theme-switch">
                <span class='mr-2'>Light</span>
                <label class="switch">
                    <input type="checkbox" @change="toggleTheme()" v-model="isDarkTheme" />
                    <span class="slider"></span>
                </label>
                <span class='ml-2'>Dark</span>
            </div>
            <div class="col-2" >
                <div v-if="lifeTimeStats && lifeTimeStats.length > 0" class="sub-state">Lifetime Statistics</div>
            </div>
            <div class="col-7 d-flex justify-content-center align-items-center">
                <div class="d-flex align-items-center">
                    <select class="form-control mr-2" v-model="selectedYear" @change="setActiveMonth(selectedMonth)">
                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                    </select>
                    <select class="form-control" v-model="selectedMonth" @change="setActiveMonth(selectedMonth)">
                        <option v-for="(month, index) in months" :key="index" :value="month">{{ month }}</option>
                    </select>
                    <div class="priority-icon-container">
                        <span class="material-icons priority-icon" title="The count also includes the events which have not been assigned yet.">priority_high</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 3 parts -->
        <div class="row ffo">
            <!-- left parts -->
            <div class="col-sm-2 mid-box">
                
                <div class="row ">
                    <div class="sub-box">
                        
                        <div class=''>
                            <div class="container">
                            <div class="row" v-for="(item, index) in lifeTimeStats" :key="index">
                            <div class="col-4 count-box">{{item.count}}</div>
                                <div class="col-8 title-box">{{item.typename}}s</div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="sub-box">
                        <div class="sub-heading">Subprogram</div>
                        <div class='sub-box-2'>
                            <div v-for="(item) in subProgramData" :key="item.id" class="check-box-container">
                                <input class="checkBox" type="checkbox" :value="item.id" v-model="payload.subprogramIds" @change="handleSelectionChange" />
                                <label class="form-check-label fz-14">
                                    {{ item.title }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="sub-box">
                        <div class="sub-heading">Donors</div>
                        <div class='sub-box-2'>
                            <div  v-for="(item) in donorsData" :key="id" class="check-box-container">
                                <input class="checkBox" type="checkbox" :value="item.id" v-model="payload.donerIds" @change="handleSelectionChange" />
                                <label class="form-check-label fz-14">
                                    {{ item.title }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="sub-box">
                        <div class="sub-heading">Thematic Area</div>
                        <div class='sub-box-2'>
                            <div  v-for="(item) in thematicArea" :key="id" class="check-box-container">
                                <input class="checkBox" type="checkbox" :value="item.id" v-model="payload.thematicIds" @change="handleSelectionChange" />
                                <label class="form-check-label fz-14">
                                    {{ item.name }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- middle parts -->
            <div class="col-sm-7 mid-box">
               
                <div class="row mt10">
                    <div class="col-4 pt-2">
                        <div class="d-flex box-2">
                            <div class="left-side">
                                <span>
                                    <span class="material-icons custom-icon">assessment</span>
                                </span>
                            </div>
                            <div class="right-side c1">
                                <div class="">Total Trainings</div>
                                <!-- <div class="pl-16">Hamza</div> -->
                                <div class="">{{trainingsCount }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 pt-2">
                        <div class="d-flex box-2">
                            <div class="left-side">
                                <span>
                                    <span class="material-icons custom-icon">assignment</span>
                                </span>
                            </div>
                            <div class="right-side c1">
                                <div class="">Total Workshops</div>
                                <!-- <div class="pl-16">NGO</div> -->
                                <div class="">{{ workshopsCount }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 pt-2">
                        <div class="d-flex box-2">
                            <div class="left-side">
                                <span>
                                    <span class="material-icons custom-icon">group</span>
                                </span>
                            </div>
                            <div class="right-side c1">
                                <div class="">Total Participants</div>
                                <!-- <div class="pl-16">Ali</div> -->
                                <div class="">{{ participantsCount }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-6 mt-2">
                        <div class="graph-box">
                            <div class="graph-heading">Total Trainings</div>
                            <div class="graph-box2">
                                <canvas ref="columnChart"></canvas>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 mt-2">
                        <div class="graph-box">
                            <div class="graph-heading">Total Participants</div>
                            <div class="graph-box2">
                                <canvas ref="barChart"></canvas>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 mt-2">
                        <div class="graph-box">
                            <div class="graph-heading">Total Events</div>
                            <div class="graph-box2">
                                <canvas ref="eventColumnChart"></canvas>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 mt-2">
                        <div class="graph-box">
                            <div class="graph-heading">Total Participants</div>
                            <div class="graph-box2">
                                <canvas ref="eventBarChart"></canvas>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- right parts -->
            <div class="col-sm-3 last-box">
                <div class="row">
                    <div class="col-12 mt-2">
                        <div class="">
                            <div class="graph2-heading">Knowledge Change</div>
                            <div class="graph-box3">
                                <canvas ref="knowledgeChangeChart"></canvas>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-2">
                        <div class="">
                            <div class="graph2-heading">Gender Wise</div>
                            <div class="graph-box3">
                                <canvas ref="genderChart"></canvas>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-2">
                        <div class="">
                            <div class="graph2-heading">Top 5 Donors</div>
                            <div class="graph-box3">
                                <canvas ref="donorChart"></canvas>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
import axios from "axios";
import Chart from 'chart.js';


export default {
    data: () => ({
        theme: 'light-theme',
        // theme: 'light-theme',
        userId: JSON.parse(localStorage.getItem("currentUser")).id,
        userRole: localStorage.getItem("isPermission"),
        BASE_PATH: process.env.VUE_APP_BASE_PATH,
        isDarkTheme: false,
        subProgramData: [],
        selectedSubProgram: [],
        donorsData: [],
        thematicArea: [],
        lifeTimeStats: [],
        trainingsDate: {},
        workshopsDate: {},
        months: ["All", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        years: Array.from({length: 12}, (_, i) => 2015 + i), // Creates array from 2015 to 2026
        selectedMonth: "All",
        selectedYear: 2025,
        trainingsStats: [],
        genderCount: [],
        payload: {
            subprogramIds: [],
            donerIds: [],
            thematicIds: [],
            year: "2025", // Default to 2024
            month: "All"  // Default to All
        },
        // Add chart instance tracking
        chartInstances: {
            columnChart: null,
            barChart: null,
            eventColumnChart: null,
            eventBarChart: null,
            knowledgeChangeChart: null,
            genderChart: null,
            donorChart: null
        }
    }),

    mounted() {
        this.initializeDashboard();
    },
    methods: {
        abbreviateProvinceName(name) {
            const abbreviations = {
                'Azad Jammu and Kashmir (AJK)': 'PAK',
                'Pakistan Administered Kashmir':'PAK',
                'Pakistan Administered Area, Kashmir (PAK)' : 'PAK',
                'Khyber Pakhtunkhwa': 'KP',
                'Gilgit-Baltistan': 'GB'
            };
            return abbreviations[name] || name;
        },
        destroyCharts() {
            // Destroy all existing chart instances
            Object.keys(this.chartInstances).forEach(key => {
                if (this.chartInstances[key]) {
                    this.chartInstances[key].destroy();
                    this.chartInstances[key] = null;
                }
            });
        },
        async initializeDashboard() {
            this.openLoading();
            try {
                // Destroy existing charts before creating new ones
                this.destroyCharts();
                
                await Promise.all([
                    this.getKnowledgeChange(),
                    this.getSubProgram(),
                    this.getDonors(),
                    this.getThematicArea(),
                    this.getLifeTimeStats(),
                    this.getGenderCount(),
                    this.getTrainingsData(),
                    this.getEventsData(),
                    this.getDonorCount(),
                    this.getStats()
                ]);
            } catch (error) {
                // console.error("Error initializing dashboard:", error);
            } finally {
                this.closeLoading();
            }
        },
        async getSubProgram() {
            try {
                // const response = await axios.get(process.env.VUE_APP_BASE_PATH + "/subprograms/get-all");
                let endpoint = "";
                     switch (this.userRole) {
                        case "admin":
                        case "comm_officer":
                        case "country_represent":
                             endpoint = "/subprograms/get-all";
                             break;
                         case "advisor":
                             endpoint = `/subprograms/get-all?advisor_id=${this.userId}`;
                             break;
                         case "program_officer":
                             endpoint = `/subprograms/get-all?programofficer_id=${this.userId}`;
                             break;
                         default:
                             throw new Error("Invalid user role");
                             }
                 const response = await axios.get(this.BASE_PATH + endpoint);             

                if (response.data.unAuth || response.data.tokenExpired) {
                    const errorMessage = response.data.unAuth ? 'You are Unauthorized. Need to Login Again' : response.data.tokenExpired;
                    this.$toasted.global.errorMsg(errorMessage);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                    return;
                }
                this.subProgramData = response.data;
            } catch (error) {
                // console.error("Error fetching Sub Programs:", error);
                throw error;
            }
        },
        async getDonors() {
            try {
                // const response = await axios.get(process.env.VUE_APP_BASE_PATH + "/donernames/get");
                let endpoint = "";
                     switch (this.userRole) {
                        case "admin":
                        case "comm_officer":
                        case "country_represent":
                             endpoint = "/donernames/get";
                             break;
                         case "advisor":
                             endpoint = `/donernames/get?advisor_id=${this.userId}`;
                             break;
                         case "program_officer":
                             endpoint = `/donernames/get?programofficer_id=${this.userId}`;
                             break;
                         default:
                             throw new Error("Invalid user role");
                         }
                const response = await axios.get(this.BASE_PATH + endpoint);         
                if (response.data.unAuth || response.data.tokenExpired) {
                    const errorMessage = response.data.unAuth ? 'You are Unauthorized. Need to Login Again' : response.data.tokenExpired;
                    this.$toasted.global.errorMsg(errorMessage);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                    return;
                }
                this.donorsData = response.data;
            } catch (error) {
                // console.error("Error fetching Sub Project:", error);
                throw error;
            }
        },
        async getThematicArea() {
            try {
                // const response = await axios.get(process.env.VUE_APP_BASE_PATH + "/show/thematicArea/get");
                let endpoint = "";
                     switch (this.userRole) {
                        case "admin":
                        case "comm_officer":
                        case "country_represent":
                             endpoint = "/show/thematicArea/get";
                             break;
                         case "advisor":
                             endpoint = `/show/thematicArea/get?advisor_id=${this.userId}`;
                             break;
                         case "program_officer":
                             endpoint = `/show/thematicArea/get?programofficer_id=${this.userId}`;
                             break;
                         default:
                             throw new Error("Invalid user role");
                         }
                const response = await axios.get(this.BASE_PATH + endpoint);   
                if (response.data.unAuth || response.data.tokenExpired) {
                    const errorMessage = response.data.unAuth ? 'You are Unauthorized. Need to Login Again' : response.data.tokenExpired;
                    this.$toasted.global.errorMsg(errorMessage);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                    return;
                }
                this.thematicArea = response.data;
            } catch (error) {
                // console.error("Error fetching Sub Project:", error);
                throw error;
            }
        },
        async getLifeTimeStats() {
            try {
                // const filteredPayload = this.getFilteredPayload();
                const response = await axios.post(
                    process.env.VUE_APP_BASE_PATH + "/dashboard-stats/training-type-wise-counts",
                    {}
                );
                if (response.data.unAuth || response.data.tokenExpired) {
                    const errorMessage = response.data.unAuth ? 'You are Unauthorized. Need to Login Again' : response.data.tokenExpired;
                    this.$toasted.global.errorMsg(errorMessage);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                    return;
                }
                // Clear existing data first
                this.lifeTimeStats = [];
                // Set new data after a small delay to ensure proper reactivity
                setTimeout(() => {
                    this.lifeTimeStats = response.data;
                }, 0);
            } catch (error) {
                // console.error("Error fetching Sub Project:", error);
                throw error;
            }
        },
        getFilteredPayload() {
            const filteredPayload = {};
            
            if (this.payload.subprogramIds && this.payload.subprogramIds.length > 0) {
                filteredPayload.subprogramIds = this.payload.subprogramIds;
            }
            
            if (this.payload.donerIds && this.payload.donerIds.length > 0) {
                filteredPayload.donerIds = this.payload.donerIds;
            }
            
            if (this.payload.thematicIds && this.payload.thematicIds.length > 0) {
                filteredPayload.thematicIds = this.payload.thematicIds;
            }
            
            // Always include year
            filteredPayload.year = this.payload.year;
            
            // Include month only if not "All"
            if (this.payload.month && this.payload.month !== "All") {
                filteredPayload.month = this.payload.month;
            }
            
            return filteredPayload;
        },
        async getTrainingsData() {
            try {
                let endpoint = "";
                     switch (this.userRole) {
                        case "admin":
                        case "comm_officer":
                        case "country_represent":
                             endpoint = "/dashboard-stats/get-all-trainings-district-wise-counts";
                             break;
                         case "advisor":
                             endpoint = `/dashboard-stats/get-all-trainings-district-wise-counts?advisor_id=${this.userId}`;
                             break;
                         case "program_officer":
                             endpoint = `/dashboard-stats/get-all-trainings-district-wise-counts?programofficer_id=${this.userId}`;
                             break;
                         default:
                             throw new Error("Invalid user role");
                         } 
                const filteredPayload = this.getFilteredPayload();
                const response = await axios.post( this.BASE_PATH + endpoint, Object.keys(filteredPayload).length > 0 ? filteredPayload : null);
                if (response.data.unAuth || response.data.tokenExpired) {
                    const errorMessage = response.data.unAuth ? 'You are Unauthorized. Need to Login Again' : response.data.tokenExpired;
                    this.$toasted.global.errorMsg(errorMessage);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                    return;
                }
                this.trainingsDate = response.data;
                this.columnChart(response.data.getTrainingCountsBasedOnDistricts.filter(item => item.provinceName !== "Unknown"));
                this.barChart(response.data.getTraineesWhoEverEnrolledInTrainings.filter(item => item.provinceName !== "Unknown"));
            } catch (error) {
                // console.error("Error fetching training data:", error);
                throw error;
            }
        },
        async getDonorCount() {
            try {
                let endpoint = "";
                     switch (this.userRole) {
                        case "admin":
                        case "comm_officer":
                        case "country_represent":
                             endpoint = "/dashboard-stats/get-top-five-doners-counts";
                             break;
                         case "advisor":
                             endpoint = `/dashboard-stats/get-top-five-doners-counts?advisor_id=${this.userId}`;
                             break;
                         case "program_officer":
                             endpoint = `/dashboard-stats/get-top-five-doners-counts?programofficer_id=${this.userId}`;
                             break;
                         default:
                             throw new Error("Invalid user role");
                         }
                const filteredPayload = this.getFilteredPayload();
                const response = await axios.post( this.BASE_PATH + endpoint,
                    Object.keys(filteredPayload).length > 0 ? filteredPayload : null
                );
                const donorCount = response.data;
                if (donorCount && donorCount.length > 0 && this.$refs.donorChart) {
                    // Destroy existing chart instance if it exists
                    if (this.chartInstances.donorChart) {
                        this.chartInstances.donorChart.destroy();
                    }
                    
                    const ctx = this.$refs.donorChart.getContext("2d");
                    const labels = donorCount.map((item) => this.abbreviateProvinceName(item.donerId));
                    const data = donorCount.map((item) => item.count);

                    this.chartInstances.donorChart = new Chart(ctx, {
                        type: "horizontalBar",
                        data: {
                            labels,
                            datasets: [{
                                data,
                                backgroundColor: ["#63b94b", "#ff6882", "#2d4669", "#EA7D3A"],
                                borderWidth: 1
                            }]
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                datalabels: {
                                    color: "black",
                                    anchor: "end",
                                    // align: "right",
                                    font: {
                                        size: 12,
                                        weight: "bold"
                                    },
                                    formatter: (value) => value.toLocaleString(),
                                    padding: 6
                                }
                            },
                            scales: {
                                xAxes: [{
                                    ticks: {
                                        beginAtZero: true,
                                        fontSize: 14,
                                        callback: (value) => value.toLocaleString()
                                    },
                                    gridLines: {
                                        display: false
                                    }
                                }],
                                yAxes: [{
                                    ticks: {
                                        
                                        fontSize: 12,
                                        fontStyle: 'bold'
                                    },
                                    gridLines: {
                                        display: true
                                    }
                                }]
                            },
                            legend: {
                                display: false
                            },
                            tooltips: {
                                enabled: true,
                                callbacks: {
                                    label: (tooltipItem) => {
                                        return `Count: ${tooltipItem.xLabel.toLocaleString()}`;
                                    }
                                }
                            }
                        }
                    });
                }
            } catch (error) {
                // console.error("Error fetching donor count:", error);
                throw error;
            }
        },
        async getKnowledgeChange() {
            try {

                const filteredPayload = this.getFilteredPayload();
                // const response = await axios.post(
                //     process.env.VUE_APP_BASE_PATH + "/dashboard-stats/get-all-knowledge-change",
                //     Object.keys(filteredPayload).length > 0 ? filteredPayload : null
                // );
                let endpoint = "";
                     switch (this.userRole) {
                        case "admin":
                        case "comm_officer":
                        case "country_represent":
                             endpoint = "/dashboard-stats/get-all-knowledge-change";
                             break;
                         case "advisor":
                             endpoint = `/dashboard-stats/get-all-knowledge-change?advisor_id=${this.userId}`;
                             break;
                         case "program_officer":
                             endpoint = `/dashboard-stats/get-all-knowledge-change?programofficer_id=${this.userId}`;
                             break;
                         default:
                             throw new Error("Invalid user role");
                         }
                
                const response = await axios.post( this.BASE_PATH + endpoint,
                    Object.keys(filteredPayload).length > 0 ? filteredPayload : null
                ); 
                const knowledgeChange = response.data;
                if (knowledgeChange && 
                    (knowledgeChange.prePercentage !== undefined || knowledgeChange.postPercentage !== undefined) &&
                    this.$refs.knowledgeChangeChart) {
                    
                    // Destroy existing chart instance if it exists
                    if (this.chartInstances.knowledgeChangeChart) {
                        this.chartInstances.knowledgeChangeChart.destroy();
                    }
                    
                    const ctx = this.$refs.knowledgeChangeChart.getContext("2d");
                    const labels = ["Pre Percentage", "Post Percentage"];
                    const data = [
                        knowledgeChange.prePercentage || 0,
                        knowledgeChange.postPercentage || 0
                    ];
                    const total = data.reduce((sum, value) => sum + value, 0);
                    const backgroundColor = ["#ffd36e", "#76c76b"];

                    this.chartInstances.knowledgeChangeChart = new Chart(ctx, {
                        type: "doughnut",
                        data: {
                            labels,
                            datasets: [{
                                data,
                                backgroundColor,
                                borderWidth: 1,
                            }],
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            legend: {
                                position: "bottom",
                            },
                            tooltips: {
                                enabled: true,
                                callbacks: {
                                    label: (tooltipItem, data) => {
                                        const label = data.labels[tooltipItem.index];
                                        const value = data.datasets[0].data[tooltipItem.index];
                                        const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : "0";
                                        return `${label}: ${percentage}%`;
                                    },
                                },
                            },
                            plugins: {
                                datalabels: {
                                    color: "black",
                                    font: {
                                        size: 12,
                                        weight: "bold",
                                    },
                                    formatter: (value) => {
                                        const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : "0";
                                        return `${percentage}%`;
                                    },
                                },
                            },
                        },
                    });
                }
            } catch (error) {
                // console.error("Error fetching knowledge change:", error);
                throw error;
            }
        },
        async getGenderCount() {
            try {
                let endpoint = "";
                     switch (this.userRole) {
                        case "admin":
                        case "comm_officer":
                        case "country_represent":
                             endpoint = "/dashboard-stats/get-all-trainees-gender-counts";
                             break;
                         case "advisor":
                             endpoint = `/dashboard-stats/get-all-trainees-gender-counts?advisor_id=${this.userId}`;
                             break;
                         case "program_officer":
                             endpoint = `/dashboard-stats/get-all-trainees-gender-counts?programofficer_id=${this.userId}`;
                             break;
                         default:
                             throw new Error("Invalid user role");
                         }
                
                const filteredPayload = this.getFilteredPayload();
                const response = await axios.post(
                    this.BASE_PATH + endpoint,
                    Object.keys(filteredPayload).length > 0 ? filteredPayload : null
                );
                this.genderCount = response.data.genderCountsWhoEverEnrolled;
                const genderWise = response.data;
                if (genderWise && this.$refs.genderChart) {
                    // Destroy existing chart instance if it exists
                    if (this.chartInstances.genderChart) {
                        this.chartInstances.genderChart.destroy();
                    }
                    
                    const ctx = this.$refs.genderChart.getContext("2d");
                    const genders = ['Female', 'Male', 'Rather Not Say'];
                    
                    const enrolledData = [
                        
                        genderWise.genderCountsWhoEverEnrolled.find(g => g.gender === 'female')?.count || 0,
                        genderWise.genderCountsWhoEverEnrolled.find(g => g.gender === 'male')?.count || 0,
                        genderWise.genderCountsWhoEverEnrolled.find(g => g.gender === 'rather not say')?.count || 0
                    ];
                    
                    
                    this.chartInstances.genderChart = new Chart(ctx, {
                        type: 'bar',
                        data: {
                            labels: genders,
                            datasets: [
                                {
                                    data: enrolledData,
                                    backgroundColor: [
                                        '#82aff0', // Not Specified
                                        '#ff6882', // Female
                                        '#2084c7', // Male
                                        '#7FD1B9'  // Rather not say
                                    ],
                                    borderColor: [
                                        '#82aff0',
                                        '#ff6882',
                                        '#2084c7',
                                        '#7FD1B9'
                                    ],
                                    borderWidth: 1
                                }
                            ]
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                datalabels: {
                                    color: "black",
                                    anchor: "end",
                                    
                                    font: {
                                        size: 12,
                                        weight: "bold"
                                    },
                                    formatter: (value) => value.toLocaleString(),
                                    
                                }
                            },
                            scales: {
                                yAxes: [{
                                    ticks: {
                                        beginAtZero: true,
                                        fontColor: "#0c0c0b"
                                    },
                                    gridLines: {
                                        display: false
                                    }
                                }],
                                xAxes: [{
                                    ticks: {
                                        fontColor: "#0c0c0b"
                                    },
                                    gridLines: {
                                        display: false
                                    }
                                }]
                            },
                            legend: {
                                display: false
                            },
                            tooltips: {
                                mode: 'index',
                                intersect: false,
                                callbacks: {
                                    label: function(tooltipItem) {
                                        return tooltipItem.yLabel.toLocaleString();
                                    }
                                }
                            }
                        }
                    });
                }
            } catch (error) {
                // console.error("Error fetching gender count:", error);
                throw error;
            }
        },
        async getEventsData() {
            try {
                let endpoint = "";
                     switch (this.userRole) {
                        case "admin":
                        case "comm_officer":
                        case "country_represent":
                             endpoint = "/dashboard-stats/get-all-events-district-wise-counts";
                             break;
                         case "advisor":
                             endpoint = `/dashboard-stats/get-all-events-district-wise-counts?advisor_id=${this.userId}`;
                             break;
                         case "program_officer":
                             endpoint = `/dashboard-stats/get-all-events-district-wise-counts?programofficer_id=${this.userId}`;
                             break;
                         default:
                             throw new Error("Invalid user role");
                         }
            
                const filteredPayload = this.getFilteredPayload();
                const response = await axios.post(
                    this.BASE_PATH + endpoint,
                    Object.keys(filteredPayload).length > 0 ? filteredPayload : null
                );
                if (response.data.unAuth || response.data.tokenExpired) {
                    const errorMessage = response.data.unAuth ? 'You are Unauthorized. Need to Login Again' : response.data.tokenExpired;
                    this.$toasted.global.errorMsg(errorMessage);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                    return;
                }
                this.workshopsDate = response.data;
                this.eventColumnChart(response.data.getEventCountsBasedOnDistricts.filter(item => item.provinceName !== "Unknown"));
                this.eventBarChart(response.data.getTraineesWhoEverEnrolledInEvents.filter(item => item.provinceName !== "Unknown"));
            } catch (error) {
                // console.error("Error fetching events data:", error);
                throw error;
            }
        },
        async getStats() {
            try {
                let endpoint = "";
                     switch (this.userRole) {
                        case "admin":
                        case "comm_officer":
                        case "country_represent":
                             endpoint = "/dashboard-stats/training-type-wise-counts";
                             break;
                         case "advisor":
                             endpoint = `/dashboard-stats/training-type-wise-counts?advisor_id=${this.userId}`;
                             break;
                         case "program_officer":
                             endpoint = `/dashboard-stats/training-type-wise-counts?programofficer_id=${this.userId}`;
                             break;
                         default:
                             throw new Error("Invalid user role");
                         }
                const filteredPayload = this.getFilteredPayload();
                const response = await axios.post(
                    this.BASE_PATH + endpoint,
                    Object.keys(filteredPayload).length > 0 ? filteredPayload : null
                );
                if (response.data.unAuth || response.data.tokenExpired) {
                    const errorMessage = response.data.unAuth ? 'You are Unauthorized. Need to Login Again' : response.data.tokenExpired;
                    this.$toasted.global.errorMsg(errorMessage);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                    return;
                }
                this.trainingsStats = response.data;
            } catch (error) {
                throw error;
            }
        },
        toggleTheme() {
            // this.isDarkTheme = !this.isDarkTheme;
            this.theme = this.isDarkTheme ? 'dark-theme' : 'light-theme';
            document.body.className = this.theme; // Apply theme to body
            this.getTrainingsData();
            this.getEventsData();
        },
        barChart(trainees) {
            if (!this.$refs.barChart) return;
            
            // Destroy existing chart instance if it exists
            if (this.chartInstances.barChart) {
                this.chartInstances.barChart.destroy();
            }
            
            const ctx = this.$refs.barChart.getContext("2d");
            const labels = trainees.map(item => this.abbreviateProvinceName(item.provinceName));
            const data = trainees.map(item => item.count);

            this.chartInstances.barChart = new Chart(ctx, {
                type: "bar",
                data: {
                    labels,
                    datasets: [{
                        data,
                        backgroundColor: "#82aff0",
                        borderColor: "#82aff0",
                        borderWidth: 1,
                        barThickness: 30, // Set fixed bar thickness
                    }, ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        datalabels: {
                            color: this.theme === 'light-theme' ? "#079aab" : "white",
                            anchor: "end", // Position above the bar
                            // align: "start",
                            font: {
                                size: 14,
                                weight: "bold",
                            },
                            
                        },
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                stepSize: 10,
                                fontColor: this.theme === 'light-theme' ? "#0c0c0b" : "#ffff",
                            },
                            gridLines: {
                                display: false, // Hide Y-axis grid lines
                            },

                        }, ],
                        xAxes: [{
                            ticks: {
                                fontColor: this.theme === 'light-theme' ? "#0c0c0b" : "#ffff", // X-axis text color
                            },

                        }, ],
                    },
                    legend: {
                        display: false,

                    },
                },
            });
        },
        columnChart(trainingsDate) {
            if (!this.$refs.columnChart) return;
            
            // Destroy existing chart instance if it exists
            if (this.chartInstances.columnChart) {
                this.chartInstances.columnChart.destroy();
            }
            
            const ctx = this.$refs.columnChart.getContext("2d");
            const labels = trainingsDate.map(item => this.abbreviateProvinceName(item.provinceName));
            const data = trainingsDate.map(item => item.count);

            this.chartInstances.columnChart = new Chart(ctx, {
                type: "horizontalBar", // Horizontal bar chart
                data: {
                    labels,
                    datasets: [{
                        data,
                        backgroundColor: "#82aff0",
                        borderColor: "#82aff0",
                        borderWidth: 1,
                        barThickness: 30, // Set fixed bar thickness
                    }, ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        datalabels: {
                            color: this.theme === 'light-theme' ? "#079aab" : "white",
                            anchor: "end",
                            // align: "start",
                            font: {
                                size: 14,
                                weight: "bold",
                            },
                        },
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontColor: this.theme === 'light-theme' ? "#0c0c0b" : "#ffff",
                                categoryPercentage: 0.8, // Add spacing between bars
                            },
                            gridLines: {
                                display: false,
                            },
                        }, ],
                        yAxes: [{
                            ticks: {
                                fontColor: this.theme === 'light-theme' ? "#0c0c0b" : "#ffff",
                            },
                        }, ],
                    },
                    legend: {
                        display: false,
                    },
                },
            });
        },
        eventBarChart(trainees) {
            if (!this.$refs.eventBarChart) return;
            
            // Destroy existing chart instance if it exists
            if (this.chartInstances.eventBarChart) {
                this.chartInstances.eventBarChart.destroy();
            }
            
            const ctx = this.$refs.eventBarChart.getContext("2d");
            const labels = trainees.map(item => this.abbreviateProvinceName(item.provinceName));
            const data = trainees.map(item => item.count);

            this.chartInstances.eventBarChart = new Chart(ctx, {
                type: "bar",
                data: {
                    labels,
                    datasets: [{
                        data,
                        backgroundColor: "#82aff0",
                        borderColor: "#82aff0",
                        borderWidth: 1,
                        barThickness: 30, // Set fixed bar thickness
                    }, ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        datalabels: {
                            color: this.theme === 'light-theme' ? "#079aab" : "white",
                            anchor: "end", // Position above the bar
                            // align: "start",
                            font: {
                                size: 14,
                                weight: "bold",
                            },

                        },
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                stepSize: 10,
                                fontColor: this.theme === 'light-theme' ? "#0c0c0b" : "#ffff",
                            },
                            gridLines: {
                                display: false, // Hide Y-axis grid lines
                            },

                        }, ],
                        xAxes: [{
                            ticks: {
                                fontColor: this.theme === 'light-theme' ? "#0c0c0b" : "#ffff", // X-axis text color
                            },

                        }, ],
                    },
                    legend: {
                        display: false,

                    },
                },
            });
        },
        eventColumnChart(trainingsDate) {
            if (!this.$refs.eventColumnChart) return;
            
            // Destroy existing chart instance if it exists
            if (this.chartInstances.eventColumnChart) {
                this.chartInstances.eventColumnChart.destroy();
            }
            
            const ctx = this.$refs.eventColumnChart.getContext("2d");
            const labels = trainingsDate.map(item => this.abbreviateProvinceName(item.provinceName));
            const data = trainingsDate.map(item => item.count);

            this.chartInstances.eventColumnChart = new Chart(ctx, {
                type: "horizontalBar",
                data: {
                    labels,
                    datasets: [{
                        data,
                        backgroundColor: "#82aff0",
                        borderColor: "#82aff0",
                        borderWidth: 1,
                        barThickness: 30, // Set fixed bar thickness
                    }, ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        datalabels: {
                            color: this.theme === 'light-theme' ? "#079aab" : "white",
                            anchor: "end",
                            // align: "start",
                            font: {
                                size: 14,
                                weight: "bold",
                            },
                        },
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontColor: this.theme === 'light-theme' ? "#0c0c0b" : "#ffff",
                                categoryPercentage: 0.8, // Add spacing between bars
                            },
                            gridLines: {
                                display: false,
                            },
                        }, ],
                        yAxes: [{
                            ticks: {
                                fontColor: this.theme === 'light-theme' ? "#0c0c0b" : "#ffff",
                            },
                        }, ],
                    },
                    legend: {
                        display: false,
                    },
                },
            });
        },
        setActiveMonth(month) {
            this.selectedMonth = month;
            // Map month names to numbers (1-12)
            const monthMap = {
                "Jan": "01", "Feb": "02", "Mar": "03", "Apr": "04", "May": "05", "Jun": "06",
                "Jul": "07", "Aug": "08", "Sep": "09", "Oct": "10", "Nov": "11", "Dec": "12"
            };
            
            // Update the payload with year and month
            this.payload = {
                ...this.payload,
                year: this.selectedYear.toString(),
                month: month === "All" ? "All" : monthMap[month]
            };
            
            // Call handleSelectionChange to update charts
            this.handleSelectionChange();
        },
        subProgramSelection(id) {
            const index = this.selectedSubProgram.indexOf(id);
            if (index > -1) {
                this.selectedSubProgram.splice(index, 1);
            } else {
                this.selectedSubProgram.push(id);
            }
           
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        handleSelectionChange() {
            // Clear existing data before fetching new data
            this.lifeTimeStats = [];
            this.trainingsDate = {};
            this.workshopsDate = {};
            this.genderCount = [];
            
            // Destroy all charts before reinitializing
            this.destroyCharts();
            
            // Initialize dashboard with new data
            this.initializeDashboard();
        },
    },
    computed: {
        trainingsCount() {
            return this.trainingsDate.getTrainingCountsBasedOnDistricts && this.trainingsDate.getTrainingCountsBasedOnDistricts.length > 0 
                ? this.trainingsDate.getTrainingCountsBasedOnDistricts.reduce((sum, item) => sum + (item.count || 0), 0)
                : 0;
        },
        workshopsCount() {
            return this.workshopsDate.getEventCountsBasedOnDistricts && this.workshopsDate.getEventCountsBasedOnDistricts.length > 0 
                ? this.workshopsDate.getEventCountsBasedOnDistricts.reduce((sum, item) => sum + (item.count || 0), 0)
                : 0;
        },
        participantsCount() {
            return this.genderCount && this.genderCount.length > 0 
                ? this.genderCount.reduce((sum, item) => sum + (item.count || 0), 0)
                : 0;
        }
        
    }
};
</script>

<style scoped>

.ffr {
    font-family: 'Roboto', sans-serif;
}

.ffo {
    font-family: 'Open Sans', sans-serif;
}

.check-box-container {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 5px;
    margin-top: 8px;
}

.checkBox {
    flex-shrink: 0;
    margin-left: 5px;
    width: 20px;
    height: 20px;
    cursor: pointer;
}

/* Custom checkbox styling */
.checkBox[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid var(--border-color);
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    position: relative;
    background-color: var(--count-color);
}

.checkBox[type="checkbox"]:checked {
    background-color: var(--border-color);
}

.checkBox[type="checkbox"]:checked::after {
    content: '✓';
    position: absolute;
    color: white;
    font-size: 16px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.fz-14 {
    font-size: 14px;
    line-height: 1.2;
    font-weight: 500
}

.d-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.left-side {
    flex: 0 0 auto;
    margin-right: 20px;
}

.right-side {
    flex: 1;
}

.c1 {
    font-size: 12px;
    font-weight: 700;
    color: var(--icon-bg);
}

.pl-16 {
    padding-left: 16px;
}

.ml2 {
    margin-left: 2px
}

.btn-light {
    border-radius: 0;
}

/* --- theme ---*/

/* Define light theme */
.light-theme {
    --header-bg-color: #079aab;
    --subheading-bg-color: #ffb55c;
    --graph-heading-color: #079aab;
    --box-bg-color: #ffff;
    --mid-box: #eee;
    --last-box: #eee;
    --graph-heading: #079aab;
    --graph-text: #ffff;
    --graph-bg-color: #ffff;
    --text-color: #ffff;
    --btn-color: #ffbe61;
    --count-color: #e2eef0;
    --month-color: #eee;
    --border-color: #079aab;
    --border-2: #c3e2e7;
    --icon-bg: #079aab;
    --btn-text: #ffff;
}

/* Define dark theme */
.dark-theme {
    --header-bg-color: #1e2d46;
    --subheading-bg-color: #1e2d46;
    --graph-heading-color: #1e2d46;
    --box-bg-color: #82aff0;
    --mid-box: #3c64a0;
    --last-box: #ffff;
    --graph-heading: #82aff0;
    --graph-text: #2d4669;
    --graph-bg-color: #2d4669;
    --text-color: #ffffff;
    --btn-color: #ffff;
    --count-color: #82aff0;
    --month-color: #1e2d46;
    --border-color: #1e2d46;
    --border-2: #82aff0;
    --icon-bg: #1e2d46;
    --btn-text: #0c0c0b;
}

/* Apply theme variables */
.heading {
    background-color: var(--header-bg-color);
    position: relative;
    color: var(--text-color);

}

.count-box {
    border: 2px solid var(--border-color);
    text-align: center;
    background: var(--count-color);
    font-size: 16px;
    font-weight: 600;
}

.title-box {
    border: 2px solid var(--border-color);
    background: var(--count-color);
    font-size: 12px;
    font-weight: 600;
}

.sub-box {
    width: 100%;

}

.sub-box-2 {
    height: 19vh;
    overflow-y: auto;
    overflow-x: hidden;
    border: 1px solid;
    border-top: 1px solid var(--subheading-bg-color);
    background-color: var(--count-color);
}

.sub-heading {
    background: var(--subheading-bg-color);
    color: #ffff;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    border-radius: 10px 10px 0 0;
}
.sub-state{
    color: #ffff;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
}
.graph2-heading {
    background: var(--graph-heading-color);
    color: #ffff;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    border-radius: 10px 10px 0 0;
}

.month-box {
    background-color: var(--month-color);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}

.box-2 {
    border: 1px solid var(--border-2);
    border-radius: 50px;
    padding: 6px;
    background: var(--count-color);
}

.mid-box {
    background-color: var(--mid-box);
}

.last-box {
    background-color: var(--last-box);
}

.graph-box {
    border-radius: 10px;
    width: 100%;
}

.graph-box2 {
    height: 34vh;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: var(--graph-bg-color);
    border: 1px solid;
    border-top: 1px solid var(--graph-bg-color);
    border-radius: 0 0 5px 5px;
}

.graph-box3 {
    height: 24vh;
    overflow-y: auto;
    overflow-x: hidden;
    border: 1px solid;
    border-radius: 0 0 10px 10px;
}

.graph-heading {
    background: var(--graph-heading);
    color: var(--graph-text);
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    border-radius: 10px 10px 0 0;
}

.graph2-box {
    border: 1px solid;
    border-radius: 0 0 10px 10px;
    width: 100%;
    height: 24vh;
}

.btn-month {
    background: var(--btn-color);
    color: var(--btn-text);
    font-size: 14px;
    border-radius: 0px;
}

.btn-month:hover {
    background: yellow;
}

.btn-month.active {
    background: yellow;
    color: black;
}

.custom-icon {
    font-size: 36px !important;
    color: white;
    background-color: var(--icon-bg);
    border-radius: 50%;
    padding: 10px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
}

.theme-switch {
    position: absolute;
    right: 10px;
    top: 9px;
   
}

/* Switch container */
.switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
}

/* Hide default checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;
}

.slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 4px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
}

input:checked+.slider {
    background-color: #2196F3;
}

input:checked+.slider:before {
    transform: translateX(24px);
}

canvas {
    width: 100% !important;
    height: 100% !important;
}

.form-control{
    width: 90px;
}

/* Dropdown styles */
select.form-control {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding: 8px 12px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    background-color: var(--count-color);
    cursor: pointer;
    position: relative;
    color: var(--icon-bg);
}

/* Style for dropdown options */
select.form-control option {
    background-color: var(--count-color);
    color: var(--icon-bg);
    padding: 10px;
}

/* Highlight selected option */
select.form-control option:checked {
    background-color: var(--header-bg-color);
    color: white;
}

/* Add custom dropdown arrow */
select.form-control {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 16px;
    padding-right: 32px;
}

.row.mt10 {
    position: relative;
}

.row.mt10::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 60%;
    background-color: var(--header-bg-color);
    z-index: 0;
}

.row.mt10 > div {
    position: relative;
    z-index: 1;
}

.priority-icon-container {
    margin-left: 10px;
    cursor: help;
    position: relative;
}

.priority-icon {
    font-size: 20px;
    vertical-align: middle;
    background: rgb(238, 65, 65);
    border-radius: 50%;
    padding: 4px;
    color: white;
}

.priority-icon-container:hover::after {
    content: "The count also includes the events which have not been assigned yet.";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: white;
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    white-space: nowrap;
    z-index: 1000;
    margin-bottom: 5px;
}

.priority-icon-container:hover::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
    margin-bottom: -5px;
}

/* Add tooltip styles */
.tooltip {
    position: relative;
    display: inline-block;
}

.tooltip .tooltiptext {
    /* visibility: hidden; */
    width: 200px;
    /* background-color: var(--header-bg-color); */
    /* color: var(--text-color); */
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
}
</style>
